import { Link } from "react-router-dom";
import { Badge, type Tone } from "@/components/ui";
import { STAGE_LABEL, STAGE_TONE } from "@/lib/constants";
import { dueLabel } from "@/lib/format";
import { VERTICAL_LABEL } from "@/api/lookups";

export function StageBadge({ stage }: { stage: string }) {
  return <Badge tone={STAGE_TONE[stage] ?? "slate"}>{STAGE_LABEL[stage] ?? stage}</Badge>;
}

export function VerticalBadge({ vertical }: { vertical: string }) {
  return (
    <Badge tone={vertical === "study_abroad" ? "blue" : "green"}>
      {VERTICAL_LABEL[vertical] ?? vertical}
    </Badge>
  );
}

const dueTone: Record<string, Tone> = { bad: "red", warn: "amber", ok: "green", muted: "slate" };

export function DueBadge({ date, done }: { date?: string | null; done?: boolean }) {
  if (done) return <Badge tone="green">Done</Badge>;
  const d = dueLabel(date);
  return <Badge tone={dueTone[d.tone]}>{d.text}</Badge>;
}

export function StudentLink({ id, name }: { id: number; name: string }) {
  return (
    <Link to={`/students/${id}`} className="font-semibold text-navy hover:text-brand hover:underline">
      {name}
    </Link>
  );
}

export function targetFor(t: { lead: number | null; enrolment: number | null; student: number | null }) {
  if (t.enrolment) return `/enrolments/${t.enrolment}`;
  if (t.lead) return `/leads/${t.lead}`;
  if (t.student) return `/students/${t.student}`;
  return null;
}
